
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass('Gamification.Gamification.ProdottiEsperienzeTaskEditor')
    export class ProdottiEsperienzeTaskEditor extends Serenity.Extensions.GridEditorBase<ProdottiEsperienzeTaskRow, any> {
        protected getColumnsKey() { return ProdottiEsperienzeTaskEditorColumns.columnsKey; }
        protected getDialogType() { return ProdottiEsperienzeTaskEditorDialog; }
        protected getIdProperty() { return ProdottiEsperienzeTaskRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeTaskRow.localTextPrefix; }
        protected getService() { return ProdottiEsperienzeTaskService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 300
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.IdProdottoEsperienza > 0);
        }

        protected getColumns() {
            var columns = super.getColumns();

            //
            if (!Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Add column
                columns.unshift({
                    field: 'Delete Row',
                    name: '',
                    format: ctx => '<a class="inline-action delete-row" title="Elimina">' +
                        '<i class="fa fa-trash-o text-red"></i></a>',
                    width: 24,
                    minWidth: 24,
                    maxWidth: 24
                });
            }

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        this.view.deleteItem(item.IdProdottoEsperienzaTask);
                    });
                }

                if (target.hasClass('points-row')) {
                    //                        var dlg = new Northwind.OrderDialog();
                    //    this.initDialog(dlg);
                    //    dlg.loadEntityAndOpenDialog(<Northwind.OrderRow>{
                    //        CustomerID: item.CustomerID
                    //    });
                }
            }
        }

        private _IdProdottoEsperienza: number;

        get IdProdottoEsperienza() {
            return this._IdProdottoEsperienza;
        }

        set IdProdottoEsperienza(value: number) {
            if (this._IdProdottoEsperienza != value) {
                this._IdProdottoEsperienza = value;
                this.setEquality(ProdottiEsperienzeTaskRow.Fields.IdProdottoEsperienza, value);
                this.refresh();
            }
        }
    }
}